import { useEffect, useMemo, useState } from "react";
import { Bell, Search } from "lucide-react";
import http from "../api/http";

const formatearFecha = (value) =>
  value
    ? new Date(value).toLocaleString("es-AR", { dateStyle: "short", timeStyle: "short" })
    : "-";

export default function Notificaciones() {
  const [notificaciones, setNotificaciones] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const cargar = async () => {
    try {
      setCargando(true);
      setError("");
      const { data } = await http.get("/notificaciones");
      setNotificaciones(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.response?.data?.error || "No se pudieron cargar las notificaciones.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargar();
    const actualizar = () => cargar();
    window.addEventListener("notificaciones:actualizar", actualizar);
    return () => window.removeEventListener("notificaciones:actualizar", actualizar);
  }, []);

  const filtradas = useMemo(() => {
    const query = busqueda.trim().toLowerCase();
    if (!query) return notificaciones;
    return notificaciones.filter((item) =>
      `${item.producto || ""} ${item.codigoSku || ""} ${item.tipo || ""}`.toLowerCase().includes(query),
    );
  }, [busqueda, notificaciones]);

  return (
    <div>
      {error && <div className="alert alert-error">{error}</div>}

      <section className="panel">
        <div className="toolbar">
          <div>
            <h2>Productos para comprar</h2>
            <p>Total: {filtradas.length}</p>
          </div>
          <div className="search">
            <Search size={17} />
            <input
              placeholder="Buscar por producto, SKU o tipo..."
              value={busqueda}
              onChange={(event) => setBusqueda(event.target.value)}
            />
          </div>
        </div>

        {cargando && notificaciones.length === 0 ? (
          <div className="loading-state">Calculando stock actual...</div>
        ) : filtradas.length === 0 ? (
          <div className="notification-page-empty">
            <Bell size={26} />
            <strong>No hay productos para reponer.</strong>
            <span>Las alertas apareceran cuando el stock llegue al minimo configurado.</span>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>SKU</th>
                  <th>Tipo</th>
                  <th>Stock minimo</th>
                  <th>Stock actual</th>
                  <th>Fecha de notificacion</th>
                </tr>
              </thead>
              <tbody>
                {filtradas.map((item) => (
                  <tr key={item.id}>
                    <td><strong>{item.producto}</strong></td>
                    <td>{item.codigoSku || "-"}</td>
                    <td><span className="badge warn">{item.tipo || "-"}</span></td>
                    <td>{Number(item.stockMinimo || 0).toLocaleString("es-AR")} {item.unidadMedida}</td>
                    <td><span className="stock-alert-value">{Number(item.stockActual || 0).toLocaleString("es-AR")} {item.unidadMedida}</span></td>
                    <td>{formatearFecha(item.fechaNotificacion)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
